import { ComponentPropsWithoutRef, FC } from 'react';

import { Autocomplete, TextField } from '@mui/material';

type BaseAutocompleteProps = ComponentPropsWithoutRef<typeof Autocomplete>;

type WaveUIAutocompleteProps = Omit<BaseAutocompleteProps, 'renderInput'> & {
  name: string;
  label: string;
  placeholder: string;
  error?: boolean;
  helperText?: string;
  renderInput?: BaseAutocompleteProps['renderInput'];
};

const WaveUIAutocomplete: FC<WaveUIAutocompleteProps> = (args) => {
  return (
    <Autocomplete
      {...args}
      renderInput={(params) => (
        <TextField
          {...params}
          name={args.name}
          label={args.label}
          placeholder={args.placeholder}
          error={args.error}
          helperText={args.helperText}
        />
      )}
    />
  );
};

export default WaveUIAutocomplete;
